/* eslint-disable i18next/no-literal-string */

import { useTolgee } from '@aikoa/i18n/react'
import { LoadingOverlay } from '~/components/LoadingView'

export function LanguageChangeOverlay() {
  const tolgee = useTolgee(['pendingLanguage', 'language'])

  const pendingLanguage = tolgee.getPendingLanguage()
  const currentLanguage = tolgee.getLanguage()

  const isChanging =
    pendingLanguage !== undefined && pendingLanguage !== null && pendingLanguage !== currentLanguage

  if (!isChanging) {
    return null
  }

  return <LoadingOverlay />
}
